export default __webpack_public_path__ + "static/media/others.3efeacbb.jpg";